import { gamesImagesData } from "../../utils/data/homePage.data";
import {
  DEPOSIT_ROUTE,
  EXCHANGE_EVENT_TYPES,
  fetchCasinoGamesBySections,
  fetchInplayEvent,
  fetchNotifications,
  getInplayEvents,
  getUsername,
  ICasinoGame,
  RootState,
  setCompetition,
  setEventType,
  SPORTS_MAP,
  useAppDispatch,
  useAppSelector,
  WITHDRAW_ROUTE,
} from "@hypexone/uicore";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GCImage from "../../assets/images/Casino_svg_img/GC_Logo.svg";
import LICImage from "../../assets/images/Casino_svg_img/LIC.svg";
import { commonPaddingBottomForMobile } from "../../utils/constants/common.constants";
import Button from "../components/shared/Button/Button";
import Popup from "../components/home/Popup";
import MobileFooter from "../components/mobile-footer/MobileFooter";
import NewsAndPromotions from "../components/shared/NewsAndPromotions";
import Header from "../components/header/Header";
import LiveGif from "../../assets/images/Casino_svg_img/Live.svg";
import ProvidersSection from "./ProvidersSection";
import { isDesktop, isIOS, isMobile } from "react-device-detect";
import { BsAndroid2 } from "react-icons/bs";
import { appNavigationConstants } from "../../utils/constants/header.constants";
import { connect } from "react-redux";
import { BannerObjData } from "@hypexone/uicore/lib/cjs/src/models/Banners";
import HomeGames from "./WithdrawAmount/HomeGames";
import { ACCOUNT_CLIENT } from "../../App.utils";
import { BRAND_DOMAIN, domain, BRAND_NAME } from "../../constants/Branding";
import { getEnvVariable } from "../../constants/brandConfig";
import { FaPiggyBank, FaHandHoldingDollar } from "react-icons/fa6";

const APK_POPUP_STORAGE_KEY = "apk_popup_shown";
import ClientSecurityMessageModal from "../components/header/ClientSecurityMessageModal";
import SkinsRail from "../components/header/SkinsRail";
import YuviGames from "../components/YuviGames/YuviGames";

const HomePage = ({ loggedIn, balance, exposure }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { langData } = useAppSelector((state) => state.cms);
  const { domainConfig } = useAppSelector((state) => state.common);
  const apkUrl = getEnvVariable(domain, "apk_url") || domainConfig?.apkUrl;
  const allowedTrendingNames = [
    "coin flip",
    "fortune wheel",
    "twistx",
    "lucky 5",
    "rock paper scissors",
    "valentine",
    "bolly kiss",
    "limbo",
    "plinko",
    "crash x",
    "diamonds",
    "pushpa rani",
    "dice",
  ];
  // const { loggedIn } = useAppSelector((state) => state.auth);
  const [bannersData, setBannersData] = useState<BannerObjData[]>([]);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const trending =
    useAppSelector((state) => state?.common?.trendingGames) || [];
  const games = useAppSelector((state) => state?.catalog?.mac88Games) || [];
  const filteredTrending = trending?.filter((game) => {
    return allowedTrendingNames?.includes(game.gameName.toLowerCase());
  });

  // Before and After Login Banners
  const [popupBanner, setPopupBanner] = useState<BannerObjData>();
  const [downloadApkBanner, setDownloadApkBanner] = useState<BannerObjData>();
  const [popupMobileBanner, setPopupMobileBanner] = useState<BannerObjData>();
  const [downloadApkMobileBanner, setDownloadApkMobileBanner] =
    useState<BannerObjData>();
  const [showApkPopup, setShowApkPopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [casinoGames, setCasinoGames] = useState<ICasinoGame[]>([]);
  const [casinoLobby, setCasinoLobby] = useState<ICasinoGame[]>([]);

const fetchBanners = async () => {
  const response = await ACCOUNT_CLIENT.getBannersByCategory(
    BRAND_DOMAIN,
    "diamondgifs"
  );
  setBannersData(response?.banners);
};
  useEffect(() => {
    fetchBanners();
  }, []);

  useEffect(() => {
    if (loggedIn) {
      dispatch(fetchNotifications());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn]);

  function handleNavigation(url: string) {
    // Check if the user is trying to navigate to /sportsbook and if they are logged in
    if (url === "/sportsbook" && !loggedIn) {
      setShowLoginPopup(true); // Show the popup if not logged in
      return; // Stop the navigation
    }
    navigate(url); // Navigate if allowed
  }
  // const username = sessionStorage.getItem("username");
  // const errorHandler = (error: any) => {
  //   console.log(error.response.data.message);
  // };
  // const urlsMap = getUrlMap();
  // const accountClient = new AccountClient(urlsMap, jwtToken, errorHandler);

  // const fetchData = async () => {
  //   await accountClient
  //     .getProfile(username)
  //     .then((response: { data: any }) => {
  //       console.log(response.data);
  //     })
  //     .catch((error: any) => {
  //       console.log(error);
  //     });
  // };
  // useEffect(() => {
  //   fetchData();
  // }, []);

  const { events: catalogEvents, selectedEventType } = useAppSelector(
    (state) => state.catalog
  );
  const { allowedConfig } = useAppSelector((state) => state.common);

  const inplayEvents = getInplayEvents(catalogEvents, allowedConfig);

  // Create a combined array of all sports with their event counts
  const allSportsWithCounts = EXCHANGE_EVENT_TYPES.map(sport => {
    const inplayEvent = inplayEvents.find(event => 
      event.sportName.toLowerCase() === sport.name.toLowerCase()
    );
    return {
      ...sport,
      eventCount: inplayEvent ? inplayEvent.events.length : 0,
      sportName: sport.name
    };
  });

  useEffect(() => {
    dispatch(fetchInplayEvent());
  }, []);

  const handleNavLinkClick = (title: string) => {
    dispatch(setCompetition({ id: "", name: "", slug: "" }));

    const sport = SPORTS_MAP.get(title);
    if (sport) {
      dispatch(setEventType(sport));
    }
    const navItem = appNavigationConstants.find((item) => item.title === title);
    if (navItem) {
      navigate(navItem.navigationUrl);
    } else {
    }
  };

  const getApkPopupBanners = async () => {
    try {
      const data = await ACCOUNT_CLIENT.getBannersByCategory(
        BRAND_DOMAIN,
        "apkpopupbanner"
      );
      if (data?.banners && data.banners.length >= 2) {
        const desktop = data.banners.filter((b) => b.deviceType === "desktop")[0];
        const mobile = data.banners.filter((b) => b.deviceType === "mobile")[0];
        if (desktop && mobile) {
          setDownloadApkBanner(desktop);
          setDownloadApkMobileBanner(mobile);
          setShowApkPopup(true);
        }
      }
    } catch {
      // ignore banner fetch errors so app does not crash
    }
  };

  const getPopupBanners = async () => {
    try {
      const data = await ACCOUNT_CLIENT.getBannersByCategory(
        BRAND_DOMAIN,
        "popupbanner"
      );
      if (data?.banners && data.banners.length >= 2) {
        const desktop = data.banners.filter((b) => b.deviceType === "desktop")[0];
        const mobile = data.banners.filter((b) => b.deviceType === "mobile")[0];
        if (desktop && mobile) {
          setPopupBanner(desktop);
          setPopupMobileBanner(mobile);
        }
      }
    } catch {
      // ignore banner fetch errors so app does not crash
    }
  };

  useEffect(() => {
    if (!sessionStorage.getItem("popup_shown")) {
      getPopupBanners();
    }
  }, []);

  const closePopup = () => {
    sessionStorage.setItem("popup_shown", "true");
    setShowPopup(false);
  };

  const handlePopupBannerClick = () => {
    const banner = isMobile ? popupMobileBanner : popupBanner;
    const redirectionUrl = banner?.redirectionUrl?.trim();
    if (!redirectionUrl) return;

    closePopup();
    if (redirectionUrl.startsWith("/")) {
      navigate(redirectionUrl);
    }
  };

  useEffect(() => {
    if (loggedIn && !sessionStorage.getItem("popup_shown")) {
      setShowPopup(true);
    }
  }, [loggedIn]);

  const isApkAvailable = !!apkUrl;

  useEffect(() => {
    if (!sessionStorage.getItem(APK_POPUP_STORAGE_KEY) && isApkAvailable) {
      getApkPopupBanners();
    }
  }, [isApkAvailable]);

  const closeApkPopup = () => {
    sessionStorage.setItem(APK_POPUP_STORAGE_KEY, "true");
    setShowApkPopup(false);
  };

  const downloadApp = () => {
    if (!apkUrl) return;
    const href = apkUrl.startsWith("http") ? apkUrl : `https://${apkUrl}`;
    const link = document.createElement("a");
    link.href = href;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const result = await dispatch(
          fetchCasinoGamesBySections({
            tag: 'fantasy_sports,new_launch,recommended_games,live_casino_games,slot,casino_lobby,trending_games',
          })
        );

        const games = (result?.payload as ICasinoGame[]) || [];
        setCasinoGames(games);
        setCasinoLobby(games.filter(game => game.sectionCode == "casino_lobby"));
      } catch (error) {
        console.error("Error fetching casino games:", error);
        setCasinoGames([]);
      }
    };

    fetchGames();
  }, []);

  return (
    <div className="flex bg-[#dee2e6] flex-col h-full w-full overflow-auto gap-[1px] mb-64 router-ctn">
      <div>
        <Header balance={balance} exposure={exposure} loggedIn={loggedIn} />
      </div>
      <div
        className={`flex flex-col flex-1 px-[1px] md:px-[55px] overflow-auto hide-scrollbar bg-white pb-32 ${commonPaddingBottomForMobile}`}
      >
        <div className="flex flex-col gap-[2px]">
          <div className="hidden md:block">
            <NewsAndPromotions />
          </div>

          {loggedIn &&
            domainConfig?.payments &&
            domainConfig.b2cEnabled &&
            getUsername() !== "Demo User" && (
              <div className="md:hidden flex w-full">
                <Button
                  onClick={() => navigate(DEPOSIT_ROUTE)}
                  className="flex-1 flex gap-2 text-xs rounded items-center bg-[#008000] px-2 py-[5px] justify-center border border-white"
                >
                  <FaPiggyBank className="text-white w-4 h-4" />
                  <span className="text-white">
                    {langData?.["deposit"] ?? "Deposit"}
                  </span>
                </Button>
                <Button
                  onClick={() => navigate(WITHDRAW_ROUTE)}
                  className="flex-1 flex gap-2 text-xs rounded items-center bg-[#FF0000] py-[2px] px-2 justify-center border border-white"
                >
                  <FaHandHoldingDollar className="text-white w-4 h-4" />
                  <span className="text-white">
                    {langData?.["withdraw"] ?? "Withdraw"}
                  </span>
                </Button>
              </div>
            )}

          <div className="grid grid-cols-4 md:grid-cols-6 gap-0.5 w-full">
            {gamesImagesData.map(
              ({ imageSrc, url, alt, customClassName, title }, index) => {
                let computedClass = "";

                if (index === 0) {
                  // Full width on both mobile and desktop
                  computedClass = "col-span-4 md:col-span-6";
                } else if (index === 1) {
                  isDesktop
                    ? (computedClass = "col-span-2 md:col-span-3")
                    : (computedClass = "col-span-4 md:col-span-6");
                } else if (index === 2) {
                  isDesktop
                    ? (computedClass = "col-span-2 md:col-span-3")
                    : (computedClass = "col-span-4 md:col-span-6");
                } else {
                  // Two items per row
                  computedClass = "col-span-2 md:col-span-3";
                }

                return (
                  <div
                    key={index}
                    className={`w-full cursor-pointer relative ${computedClass}`}
                  >
                    <img
                      onClick={() => handleNavigation(url)}
                      src={imageSrc}
                      alt={alt}
                      className="w-full h-auto object-cover"
                    />

                    {index === 1 && (
                      <div className="absolute right-0 top-0 z-10 h-full bg-gradient-to-b from-black/95 to-black/30 w-[120px] md:w-[160px] text-white overflow-auto p-2">
                        <div className="w-16 h-5 overflow-hidden">
                          <img
                            className="object-cover h-4"
                            src={LiveGif}
                            alt="LiveGif"
                          />
                        </div>
                        <div className="flex flex-col gap-1">
                          {allSportsWithCounts.map((sport) => (
                            <div
                              key={sport.id}
                              className="text-[11px] leading-[10px] md:text-xs flex justify-between md:font-bold"
                              onClick={() =>
                                handleNavLinkClick(sport.sportName)
                              }
                            >
                              <div>{sport.sportName}</div>
                              <div className="bg-white text-black rounded py-[2px] px-1 font-normal">
                                {sport.eventCount}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* {title && (
                      <div className="w-full bg-black text-center uppercase font-bold text-white p-1 px-2 text-xs md:text-sm">
                        {title}
                      </div>
                    )} */}
                  </div>
                );
              }
            )}

            {showLoginPopup && (
              <Popup
                message="You must be logged in to access the Sportsbook."
                onClose={() => setShowLoginPopup(false)}
              />
            )}
          </div>
          <div className="grid  grid-cols-2 sm:grid-cols-2 gap-0.5">
            {bannersData?.map((banner) =>
              banner.deviceType === "desktop" ? (
                <div className="hidden md:block">
                  <img
                    key={banner.id}
                    src={banner.publicUrl}
                    alt={banner.title}
                    className="w-[100%] cursor-pointer"
                    onClick={
                      banner.redirectionUrl !== "nourl"
                        ? () => navigate(banner.redirectionUrl)
                        : undefined
                    }
                  />
                  <div className="flex items-center justify-center w-full h-[33px] bg-black pl-2 text-center uppercase font-bold text-white text-xs md:text-sm md:py-2 break-words">
                    {banner.title}
                  </div>
                </div>
              ) : (
                <div className="md:hidden">
                  <img
                    key={banner.id}
                    src={banner.publicUrl}
                    alt={banner.title}
                    className="w-[100%] h-[70px] sm:h-[113px] cursor-pointer"
                    onClick={
                      banner.redirectionUrl !== "nourl"
                        ? () => navigate(banner.redirectionUrl)
                        : undefined
                    }
                  />
                  <div className="flex items-center justify-center w-full h-[32px] bg-black pl-2 text-center uppercase font-bold text-white text-xs md:text-sm md:py-2 break-words">
                    {banner.title}
                  </div>
                </div>
              )
            )}
          </div>
          <HomeGames
            casinoGames={casinoGames}
            isLoggedIn={loggedIn}
            showPopUp={() => setShowLoginPopup(true)}
          />
        </div>

        {casinoLobby.length > 0 &&
          <div>
            <div
              className="w-full py-[6px] px-[5px] text-[13px] md:text-[16px] uppercase my-[2px] text-white"
              style={{
                background: "linear-gradient(-180deg, #F72424 0%, #BB1C00 100%)",
              }}
            >
              {langData?.["top_providers"]}
            </div>

            <div>
              <ProvidersSection casinoLobby={casinoLobby} />
            </div>
          </div>
        }

        <div className=" flex-col flex items-center sm:px-0  md:px-20 gap-3">
          <div className="flex flex-col w-full max-w-[670px] mx-auto gap-3">
            <div className="flex flex-col md:flex-row w-full rounded-lg border border-black2 overflow-hidden md:min-h-[140px]">
              <div className="flex justify-center items-center w-full md:w-auto md:border-r border-r-black2 px-2 py-1 md:py-0">
                <img
                  src={GCImage}
                  alt="gc-image"
                  className="w-[120px] h-auto md:w-[120px] object-contain"
                />
              </div>
              <div className="flex flex-col md:flex-row justify-center md:justify-start items-center gap-1 sm:gap-3 md:p-3 p-1 md:px-4 w-full">
                <img
                  src={LICImage}
                  alt="lic-image"
                  className="max-w-[100px] w-full h-auto object-contain"
                />
                <span className="text-[11px] text-center md:text-left leading-snug">
                  {BRAND_NAME} is the trading name of Sports Target B.V., a company
                  incorporated and regulated in Curaçao under company number
                  148053 with its registered office at Fransche Bloemweg 4,
                  Willemstad, Curaçao.
                </span>
              </div>
              {isApkAvailable && (
                <div className="flex justify-center items-center shrink-0 w-full md:w-auto md:border-t-0 md:border-l border-black2 px-3 py-2 md:py-0">
                  <button
                    type="button"
                    onClick={downloadApp}
                    className="flex md:flex-col items-center justify-center gap-2 h-[40px] md:h-[80px] px-4 rounded text-white text-sm font-bold whitespace-nowrap hover:opacity-90 transition-opacity"
                    style={{
                      background:
                        "linear-gradient(-180deg, #F72424 0%, #BB1C00 100%)",
                    }}
                  >
                    <BsAndroid2 className="text-lg shrink-0" />
                    {langData?.["download_apk"] || "Download APK"}
                  </button>
                </div>
              )}
            </div>
          </div>

          {isDesktop && (
            <div className="hidden w-full md:flex flex-col gap-2 items-center md:px-12 lg:px-20">
              <div className="text-center text-xs text-gray5 px-4">
                Our website works best in the newest and last prior version of
                these browsers: Google Chrome. Firefox
              </div>
              <div className="h-[1px] w-[76%] bg-black2" />
            </div>
          )}
          {isDesktop && (
            <div className="grid grid-cols-10 md:flex justify-center w-full text-[13px] md:text-[11px] text-black3 md:text-black underline gap-3 text-center">
              <span className="col-span-4 cursor-pointer text-right">
                Privacy Policy
              </span>
              <span className="col-span-4 cursor-pointer text-right">
                Terms And Conditions
              </span>
              <span className="col-span-6 cursor-pointer text-left">
                Rules And Regulations
              </span>

              <span className="col-span-4 cursor-pointer">About Us</span>
              <span className="col-span-4 cursor-pointer">
                Responsible Gaming
              </span>
            </div>
          )}
          {/* <div className="self-center">
            <img
              src={MobileAppQRImage}
              alt="mobile-app-qr"
              className="w-[150px]"
            />
          </div> */}
        </div>
      </div>

      {(isMobile || isIOS) ? <YuviGames /> : null}

      <div className="md:hidden">
        <MobileFooter />
      </div>

      <div>
        {!loggedIn &&
        isApkAvailable &&
        showApkPopup &&
        downloadApkBanner &&
        downloadApkMobileBanner ? (
          <ClientSecurityMessageModal
            isOpen={showApkPopup}
            onClose={closeApkPopup}
            isContentWidth
            hideCloseIcon
            modalBg="bg-transparent"
            showCloseIconInsideContent
          >
            <img
              src={
                isMobile
                  ? downloadApkMobileBanner?.publicUrl ?? ""
                  : downloadApkBanner?.publicUrl ?? ""
              }
              alt="Download APK"
              onClick={downloadApp}
              className={`cursor-pointer w-full ${isMobile ? "" : "max-h-[66vh] object-contain"}`}
            />
          </ClientSecurityMessageModal>
        ) : (
          showPopup &&
          popupBanner &&
          popupMobileBanner && (
            <ClientSecurityMessageModal
              modalBg="bg-transparent"
              isOpen={showPopup}
              onClose={closePopup}
              hideCloseIcon
              isContentWidth
              showCloseIconInsideContent
            >
              <img
                src={
                  isMobile
                    ? popupMobileBanner?.publicUrl
                    : popupBanner?.publicUrl
                }
                onClick={handlePopupBannerClick}
                className={`cursor-pointer ${isMobile ? "" : "max-h-[66vh]"}`}
              />
            </ClientSecurityMessageModal>
          )
        )}
      </div>
      <SkinsRail />
    </div>
  );
};
const mapStateToProps = (state: RootState) => {
  return {
    balance: state.auth.balanceSummary.balance,
    exposure: state.auth.balanceSummary.exposure,
    loggedIn: state.auth.loggedIn,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
